/**
 * 发送相关统计
 */
export default {
  /**
   * var {string} 协议：默认https
   */
  _protocal: 'https',

  /**
   * 发送50榜统计
   * @param {string} type 类型：ajax99, ajax87, ajax132, ajax131, ....
   * @param {object} params 上报参数
   */
  sendBang50 (type, params) {
    let url = `${this._protocal}://web.50bangzh.com/web/${type}`;
    let search = '?';
    for(let key in params) {
      search === '?' || (search += '&');
      search += `${key}=${encodeURIComponent(params[key])}`;
    }
    search += '&_=' + (new Date()).getTime() + '' + Math.random();
    let reqUrl = url + search;
    let script = document.createElement('script');
    script.src = reqUrl;
    script.defer = 'defer';
    script.onload = () => script.remove();
    document.head.appendChild(script);
  },

  /**
   * 发送ajax99统计
   * @param {string} key
   * @param {string} lO
   */
  ajax99 (key, lO) {
    let param = {
      uId2: 'SPTNPQRLSX',
      r: encodeURIComponent(key),
      lO: encodeURIComponent(lO || window.location.href),
      fBL: window.screen.width + '*' + window.screen.height
    };
    let type = 'ajax99';
    this.sendBang50(type, param);
  },

  /**
   * 设置上报协议
   * var {string} protcl 协议
   */
  setProtocol (protcl) {
    this._protocal = protcl;
  }
}
